import type { MonoTypeOperatorFunction } from 'rxjs'
import { retry, throwError, timer } from 'rxjs'

export const CUBE_RETRY_DELAYS_MS = [1000, 2000, 4000, 8000, 16000] as const

const retryableStatus = (error: unknown): boolean => {
  const status = (error as { status?: unknown } | null)?.status
  return typeof status === 'number' && (status === 0 || status === 429 || (status >= 500 && status !== 504))
}

/**
 * The cube endpoints' per-user limits answer 429 without Retry-After, and a waiting view has nothing
 * else to show. Jitter keeps a workspace's parallel cube requests from retrying in lockstep against
 * the concurrency limit.
 *
 * A 504 is a cube query that outran its timeout. It is not retried: the server-side query may still be
 * running, and a retry would stack another copy of it on the database.
 */
export const retryCubeFetch = <T>(): MonoTypeOperatorFunction<T> =>
  retry({
    count: CUBE_RETRY_DELAYS_MS.length,
    delay: (error: unknown, attempt) =>
      retryableStatus(error)
        ? timer(CUBE_RETRY_DELAYS_MS[attempt - 1] * (1 + Math.random() * 0.3))
        : throwError(() => error),
  })
